import { Button } from '@chakra-ui/react';
import { useToast } from '@src/components/chakra-ui/use-toast';
import { usePitchDeckSlideAccess } from '@src/components/sco/PitchDeckAuditor/model/access';
import { PitchDeckView } from '@src/components/sco/PitchDeckAuditor/model/types';
import { useState } from 'react';
import { LuDownload } from 'react-icons/lu';

/** Small left-nav action that downloads the full audit the viewer is allowed to read. */
export function ExportAuditButton({
  deck
}: {
  deck: PitchDeckView;
}) {
  const toast = useToast();
  const {
    canAccessFullDeck
  } = usePitchDeckSlideAccess();
  const [exporting, setExporting] = useState(false);
  const onExport = async () => {
    if (exporting) {
      return;
    }
    setExporting(true);
    try {
      const {
        downloadPitchDeckAuditPdf
      } = await import('@src/components/sco/PitchDeckAuditor/export/downloadAuditPdf');
      await downloadPitchDeckAuditPdf(deck, {
        canAccessFullDeck
      });
    } catch {
      toast({
        status: 'error',
        title: 'Could not export the PDF'
      });
    } finally {
      setExporting(false);
    }
  };
  return <Button flexShrink={0} loading={exporting} loadingText={'Preparing PDF…'} size={'xs'} variant={'outline'} width={'full'} onClick={() => void onExport()}>
      <LuDownload />
      Export PDF
    </Button>;
}